import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { groceryData } from "./grocery-data";
import cls from "./grocery.module.scss";
import { useMediaQuery } from "@mui/material";

export default function Grocery() {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery("(min-width:1024px)");
  return (
    <div className={cls.container}>
      <h1 className={cls.containerTitle}>
        {t("groceries.delivered.on.your.schedule")}
      </h1>
      <div className={cls.wrapper}>
        <Swiper
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {groceryData.map((item, index) => (
            <SwiperSlide
              key={item.id}
              className={index === 1 && isDesktop ? cls.sideBorder : ""}
            >
              <div className={cls.item}>
                <h2 className={cls.number}>{item.id}</h2>
                <h3 className={cls.title}>{t(item.titleKey)}</h3>
                <p className={cls.description}>{t(item.descriptionKey)}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
